exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sort {\n  padding: 4px 6px 4px 12px;\n  border-radius: 100px;\n}\n.sort:hover > svg {\n  color: white;\n}\n.horizontal-button {\n  border-radius: 4px;\n}\n.horizontal-button:hover > svg {\n  color: white;\n}\n.formatting-button {\n  color: rgba(184, 187, 195, 0.65);\n}\n", ""]);

// exports
